const ssr = typeof window === "undefined"

const powerBIClient = ssr ? {} : require("powerbi-client")

export { ssr, powerBIClient }
